import { ShippingMethod } from "inbounds/ShippingMethod";
import { getIsSpdDeliverr } from "./getIsSpdDeliverr";
import { getIsSpdExternal } from "./getIsSpdExternal";

export const getIsSpd = (shippingMethod?: ShippingMethod): boolean =>
  Boolean(getIsSpdDeliverr(shippingMethod) || getIsSpdExternal(shippingMethod));
